/**
 * Sanitizes a filename for use in HTTP Content-Disposition headers.
 *
 * Azure Blob Storage and HTTP headers have strict character requirements.
 * This function removes or replaces characters that are not permitted:
 * - Control characters (newlines, carriage returns, tabs, etc.)
 * - Non-ASCII characters
 * - Unescaped quotes
 *
 * @param filename - The original filename to sanitize
 * @returns A sanitized filename safe for use in HTTP headers
 */
export const sanitizeFilenameForHeader = (filename: string): string => {
  return (
    filename
      // Remove control characters (ASCII 0-31 and 127)
      // eslint-disable-next-line no-control-regex
      .replace(/[\x00-\x1F\x7F]/g, "")
      // Replace non-ASCII characters with underscore
      .replace(/[^\x20-\x7E]/g, "_")
      // Escape backslashes first (to avoid double-escaping)
      .replace(/\\/g, "\\\\")
      // Escape double quotes
      .replace(/"/g, '\\"')
  );
};
